import { render, staticRenderFns } from "./slider-tags-form.vue?vue&type=template&id=0f7550ee&"
import script from "./slider-tags-form.vue?vue&type=script&lang=js&"
export * from "./slider-tags-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports